import PropTypes from 'prop-types';
import { m } from 'framer-motion';
// @mui
import { Box } from '@mui/material';
//
import { varFade } from './variants';

// ----------------------------------------------------------------------

TextAnimate.propTypes = {
  text: PropTypes.string.isRequired,
  variants: PropTypes.object,
  sx: PropTypes.object,
  addspace: PropTypes.bool,
  component: PropTypes.string,
};

/**
 *
 * @param {{text: string, variants: any, addspace: boolean, component:string, sx: import('@mui/material').SxProps }} props
 * @returns
 */
export default function TextAnimate({ text, variants, sx, addspace, component, ...other }) {
  return (
    <Box
      component={component ? m[component] : m.h1}
      sx={{
        typography: component || 'h1',
        overflow: 'hidden',
        display: 'inline-flex',
        ...sx,
      }}
      {...other}
    >
      {addspace ? (
        <m.span variants={variants || varFade().inUp}>{text}</m.span>
      ) : (
        text.split('').map((letter, index) => (
          <m.span key={index} variants={variants || varFade().inUp}>
            {letter}
          </m.span>
        ))
      )}
    </Box>
  );
}
